import { compareByNumericProp } from '../../utils/comparators';

const getBrokenPointsForBuilding = (state, builingId) => {
  const {
    entities: {
      ingestStats: { pointMessages },
    },
  } = state;
  const forBuilding = pointMessages.filter((pm) => pm.building_id === builingId);
  forBuilding.sort(compareByNumericProp('timestamp'));
  return forBuilding;
};

export const getIngestStatsForBuilding = (state, buildingId) => {
  const {
    entities: {
      ingestStats: { buildingStats },
    },
  } = state;
  return buildingStats[buildingId] || [];
};

export const getBrokenPoints = (state, buildingId) => {
  const {
    entities: {
      points: { byId },
      ingestStats: { latestTimestamps },
    },
  } = state;
  const brokenPoints = getBrokenPointsForBuilding(state, buildingId);
  const pointsWithMessages = brokenPoints
    .map((pm) => {
      const point = byId[pm.point_id];
      if (point != null) return [point, pm];
      return null;
    })
    .filter((p) => p != null);
  const latestTimestamp = latestTimestamps[buildingId];
  return { pointsWithMessages, latestTimestamp };
};
